<template>
  <div
    class="relative my-4 flex w-full cursor-pointer flex-col items-start rounded-md outline-none"
    :tabindex="tabindex"
    @blur="open = false"
  >
    <label
      v-if="label"
      class="mb-1 text-left font-bold uppercase"
      :class="[
        customClass,
        fullWidth
          ? 'text-2xs uppercase text-dark-blue'
          : 'text-xxs text-gray-over-dark',
      ]"
      :for="label"
    >
      {{ label }}
    </label>
    <div
      class="flex h-12 cursor-pointer items-center justify-between rounded-md border border-transparent bg-off-white pl-4 text-body-color"
      :class="[
        { open: open },
        { 'light-bg': light },
        fullWidth ? 'w-full' : 'w-max',
        disabled
          ? 'cursor-not-allowed opacity-50'
          : 'hover:border-placeholder-gray',
      ]"
      @click="switchOpenStatus()"
    >
      <p :class="{ 'text-1md font-normal': fullWidth }">
        {{ isObject ? selected?.value : selected }}
      </p>
      <img
        class="mr-2 h-8 w-8 transition"
        :class="{ '-rotate-180 transform': open }"
        src="@/assets/arrow-down-black.svg"
        alt="arrow icon"
      />
    </div>
    <div
      class="absolute top-14 z-20 flex w-full flex-col items-start overflow-y-auto rounded-b-md border-b border-l border-r border-body-color bg-white"
      :class="[
        { hidden: !open },
        { light: changePosition },
        filterFor.length === 0 ? 'h-10' : '',
      ]"
      style="max-height: 200px"
      @scroll="handleScroll"
    >
      <div
        v-for="(option, i) of filterFor"
        :key="i"
        class="w-full px-4 py-2 text-left text-gray-over-dark hover:bg-off-white"
        :class="i === 0 ? 'mt-2' : ''"
        @click="select(option)"
      >
        <p :class="{ 'text-1md font-normal': fullWidth }">
          {{ isObject ? option?.value : option }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DropdownSelect',
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: [String, Object],
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    label: String,
    customClass: {
      type: String,
      default: '',
    },
    isObject: {
      type: Boolean,
      default: false,
    },
    emitOnMount: {
      type: Boolean,
      default: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
    changePosition: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selected: this.default
        ? this.default
        : this.options.length > 0
          ? this.options[0]
          : null,
      open: false,
    };
  },
  computed: {
    filterFor: function () {
      return this.options.filter((el) => el !== this.selected);
    },
  },
  mounted() {
    if (this.emitOnMount) this.$emit('input', this.selected);
  },
  methods: {
    handleScroll(e) {
      const el = e.target;
      const atBottom =
        Math.abs(el.scrollHeight - el.scrollTop - el.clientHeight) <= 1;
      if (atBottom) {
        this.$emit('scroll-bottom');
      }
    },
    switchOpenStatus() {
      if (this.disabled) return;
      this.open = !this.open;
    },
    select(option) {
      if (this.disabled) return;

      this.selected = option;
      this.open = false;
      this.$emit('input', option);
    },
  },
};
</script>
<style scoped>
.open {
  @apply rounded-b-none rounded-t-md border-l border-r border-t border-black;
  background: #fff !important;
}
.open:hover {
  @apply border-body-color;
}

.light {
  top: 40px !important;
}

.light-bg {
  background: white !important;
}
</style>
